export { default as carbonScatterMatrix } from '~icons/carbon/scatter-matrix';

export { default as emojiConstruction } from '~icons/emojione-monotone/construction';
export { default as emojiDoubleExclamationMark } from '~icons/emojione-monotone/double-exclamation-mark';
export { default as emojiWorldMap } from '~icons/emojione-monotone/world-map';
export { default as emojiZzz } from '~icons/emojione-monotone/zzz';

export { default as faDungeon } from '~icons/fa-solid/dungeon';

export { default as fluentSelectAllOff } from '~icons/fluent/select-all-off-24-regular';
export { default as fluentSelectAllOn } from '~icons/fluent/select-all-on-24-filled';
export { default as fluentAngryFaceWithHorns } from '~icons/fluent-emoji-high-contrast/angry-face-with-horns';

export { default as gameAbstract024 } from '~icons/game-icons/abstract-024';
export { default as gameAlienBug } from '~icons/game-icons/alien-bug';
export { default as gameAnimalHide } from '~icons/game-icons/animal-hide';
export { default as gameAnvil } from '~icons/game-icons/anvil';
export { default as gameBabyFace } from '~icons/game-icons/baby-face';
export { default as gameBackpack } from '~icons/game-icons/backpack';
export { default as gameBarbecue } from '~icons/game-icons/barbecue';
export { default as gameBarbute } from '~icons/game-icons/barbute';
export { default as gameBatLeth } from '~icons/game-icons/bat-leth';
export { default as gameBattleAxe } from '~icons/game-icons/battle-axe';
export { default as gameBeamsAura } from '~icons/game-icons/beams-aura';
export { default as gameBearFace } from '~icons/game-icons/bear-face';
export { default as gameBeltArmor } from '~icons/game-icons/belt-armor';
export { default as gameBigDiamondRing } from '~icons/game-icons/big-diamond-ring';
export { default as gameBladeBite } from '~icons/game-icons/blade-bite';
export { default as gameBlunderbuss } from '~icons/game-icons/blunderbuss';
export { default as gameBracer } from '~icons/game-icons/bracer';
export { default as gameBrassKnuckles } from '~icons/game-icons/brass-knuckles';
export { default as gameBroadsword } from '~icons/game-icons/broadsword';
export { default as gameBunkerAssault } from '~icons/game-icons/bunker-assault';
export { default as gameCandleLight } from '~icons/game-icons/candle-light';
export { default as gameCape } from '~icons/game-icons/cape';
export { default as gameCash } from '~icons/game-icons/cash';
export { default as gameCastle } from '~icons/game-icons/castle';
export { default as gameChestArmor } from '~icons/game-icons/chest-armor';
export { default as gameClosedDoors } from '~icons/game-icons/closed-doors';
export { default as gameCloakedFigureOnHorseback } from '~icons/game-icons/cloaked-figure-on-horseback';
export { default as gameClothes } from '~icons/game-icons/clothes';
export { default as gameCompanionCube } from '~icons/game-icons/companion-cube';
export { default as gameCrossbow } from '~icons/game-icons/crossbow';
export { default as gameCrossedSwords } from '~icons/game-icons/crossed-swords';
export { default as gameCrownedSkull } from '~icons/game-icons/crowned-skull';
export { default as gameCupcake } from '~icons/game-icons/cupcake';
export { default as gameCursedStar } from '~icons/game-icons/cursed-star';
export { default as gameCurvyKnife } from '~icons/game-icons/curvy-knife';
export { default as gameCutDiamond } from '~icons/game-icons/cut-diamond';
export { default as gameDeathSkull } from '~icons/game-icons/death-skull';
export { default as gameDiceRandom } from '~icons/game-icons/perspective-dice-six-faces-random';
export { default as gameDigDug } from '~icons/game-icons/dig-dug';
export { default as gameDorsalScales } from '~icons/game-icons/dorsal-scales';
export { default as gameEmerald } from '~icons/game-icons/emerald';
export { default as gameFairyWand } from '~icons/game-icons/fairy-wand';
export { default as gameFizzingFlask } from '~icons/game-icons/fizzing-flask';
export { default as gameFrog } from '~icons/game-icons/frog';
export { default as gameGauntlet } from '~icons/game-icons/gauntlet';
export { default as gameGladius } from '~icons/game-icons/gladius';
export { default as gameGoblinHead } from '~icons/game-icons/goblin-head';
export { default as gameGoldStack } from '~icons/game-icons/gold-stack';
export { default as gameGreaves } from '~icons/game-icons/greaves';
export { default as gameHandBag } from '~icons/game-icons/hand-bag';
export { default as gameHanger } from '~icons/game-icons/hanger';
export { default as gameHatchet } from '~icons/game-icons/hatchet';
export { default as gameHeartNecklace } from '~icons/game-icons/heart-necklace';
export { default as gameHeartPlus } from '~icons/game-icons/heart-plus';
export { default as gameHouse } from '~icons/game-icons/house';
export { default as gameJigsawBox } from '~icons/game-icons/jigsaw-box';
export { default as gameKey } from '~icons/game-icons/key';
export { default as gameKnapsack } from '~icons/game-icons/knapsack';
export { default as gameLabradorHead } from '~icons/game-icons/labrador-head';
export { default as gameLockedFortress } from '~icons/game-icons/locked-fortress';
export { default as gameLockedHeart } from '~icons/game-icons/locked-heart';
export { default as gameMagicBroom } from '~icons/game-icons/magic-broom';
export { default as gameMetalBoot } from '~icons/game-icons/metal-boot';
export { default as gameNightSky } from '~icons/game-icons/night-sky';
export { default as gameNotebook } from '~icons/game-icons/notebook';
export { default as gameOpenChest } from '~icons/game-icons/open-chest';
export { default as gamePadlock } from '~icons/game-icons/padlock';
export { default as gamePadlockOpen } from '~icons/game-icons/padlock-open';
export { default as gamePiranha } from '~icons/game-icons/piranha';
export { default as gamePocketBow } from '~icons/game-icons/pocket-bow';
export { default as gamePokecog } from '~icons/game-icons/pokecog';
export { default as gamePresent } from '~icons/game-icons/present';
export { default as gameRolledCloth } from '~icons/game-icons/rolled-cloth';
export { default as gameScrollQuill } from '~icons/game-icons/scroll-quill';
export { default as gameSecretBook } from '~icons/game-icons/secret-book';
export { default as gameShield } from '~icons/game-icons/shield';
export { default as gameShirt } from '~icons/game-icons/shirt';
export { default as gameShurikenAperture } from '~icons/game-icons/shuriken-aperture';
export { default as gameSmallFire } from '~icons/game-icons/small-fire';
export { default as gameSpellBook } from '~icons/game-icons/spell-book';
export { default as gameSpiderFace } from '~icons/game-icons/spider-face';
export { default as gameSpikedDragonHead } from '~icons/game-icons/spiked-dragon-head';
export { default as gameStarsStack } from '~icons/game-icons/stars-stack';
export { default as gameStaryu } from '~icons/game-icons/staryu';
export { default as gameStopwatch } from '~icons/game-icons/stopwatch';
export { default as gameStrongbox } from '~icons/game-icons/strongbox';
export { default as gameTeslaTurret } from '~icons/game-icons/tesla-turret';
export { default as gameThorHammer } from '~icons/game-icons/thor-hammer';
export { default as gameThumbUp } from '~icons/game-icons/thumb-up';
export { default as gameTotemHead } from '~icons/game-icons/totem-head';
export { default as gameTreasureMap } from '~icons/game-icons/treasure-map';
export { default as gameTreeFace } from '~icons/game-icons/tree-face';
export { default as gameTrident } from '~icons/game-icons/trident';
export { default as gameTrophy } from '~icons/game-icons/trophy';
export { default as gameTwirlyFlower } from '~icons/game-icons/twirly-flower';
export { default as gameTwoCoins } from '~icons/game-icons/two-coins';
export { default as gameUnstableOrb } from '~icons/game-icons/unstable-orb';
export { default as gameUpgrade } from '~icons/game-icons/upgrade';
export { default as gameWarPick } from '~icons/game-icons/war-pick';
export { default as gameWizardStaff } from '~icons/game-icons/wizard-staff';
export { default as gameWoodClub } from '~icons/game-icons/wood-club';

export { default as hisExclamationCircle } from '~icons/heroicons-solid/exclamation-circle';
export { default as hisTrash } from '~icons/heroicons-solid/trash';

export { default as icSharpMoreTime } from '~icons/ic/sharp-more-time';

export { default as mdiAccountGroupOutline } from '~icons/mdi/account-group-outline';
export { default as mdiAccountStarOutline } from '~icons/mdi/account-star-outline';
export { default as mdiAlertOutline } from '~icons/mdi/alert-outline';
export { default as mdiArrowDownBoldCircleOutline } from '~icons/mdi/arrow-down-bold-circle-outline';
export { default as mdiArrowDownBoldOutline } from '~icons/mdi/arrow-down-bold-outline';
export { default as mdiArrowLeftBoldOutline } from '~icons/mdi/arrow-left-bold-outline';
export { default as mdiArrowRightBoldOutline } from '~icons/mdi/arrow-right-bold-outline';
export { default as mdiArrowUpBoldOutline } from '~icons/mdi/arrow-up-bold-outline';
export { default as mdiAutoFix } from '~icons/mdi/auto-fix';
export { default as mdiAxeBattle } from '~icons/mdi/axe-battle';
export { default as mdiBank } from '~icons/mdi/bank';
export { default as mdiBookshelf } from '~icons/mdi/bookshelf';
export { default as mdiCalendar } from '~icons/mdi/calendar-alert';
export { default as mdiCart } from '~icons/mdi/cart';
export { default as mdiCartOutline } from '~icons/mdi/cart-outline';
export { default as mdiCashMultiple } from '~icons/mdi/cash-multiple';
export { default as mdiChartLine } from '~icons/mdi/chart-line';
export { default as mdiChatQuestionOutline } from '~icons/mdi/chat-question-outline';
export { default as mdiCheck } from '~icons/mdi/check';
export { default as mdiCheckboxBlankOutline } from '~icons/mdi/checkbox-blank-outline';
export { default as mdiCheckboxOutline } from '~icons/mdi/checkbox-outline';
export { default as mdiChevronDown } from '~icons/mdi/chevron-down';
export { default as mdiChevronRight } from '~icons/mdi/chevron-right';
export { default as mdiChevronUp } from '~icons/mdi/chevron-up';
export { default as mdiClipboardPlusOutline } from '~icons/mdi/clipboard-plus-outline';
export { default as mdiClose } from '~icons/mdi/close';
export { default as mdiCloud } from '~icons/mdi/cloud';
export { default as mdiCogOutline } from '~icons/mdi/cog-outline';
export { default as mdiCurrencyUsd } from '~icons/mdi/currency-usd';
export { default as mdiDiceMultiple } from '~icons/mdi/dice-multiple';
export { default as mdiDog } from '~icons/mdi/dog';
export { default as mdiDuck } from '~icons/mdi/duck';
export { default as mdiEmoticonDevilOutline } from '~icons/mdi/emoticon-devil-outline';
export { default as mdiExclamationThick } from '~icons/mdi/exclamation-thick';
export { default as mdiFire } from '~icons/mdi/fire';
export { default as mdiFootPrint } from '~icons/mdi/foot-print';
export { default as mdiFormatListCheckbox } from '~icons/mdi/format-list-checkbox';
export { default as mdiGiftOutline } from '~icons/mdi/gift-outline';
export { default as mdiGhost } from '~icons/mdi/ghost';
export { default as mdiHammerWrench } from '~icons/mdi/hammer-wrench';
export { default as mdiHomeOutline } from '~icons/mdi/home-outline';
export { default as mdiHourglass } from '~icons/mdi/hourglass';
export { default as mdiImageBrokenVariant } from '~icons/mdi/image-broken-variant';
export { default as mdiIsland } from '~icons/mdi/island';
export { default as mdiLetterC } from '~icons/mdi/alpha-c-circle-outline';
export { default as mdiLetterD } from '~icons/mdi/alpha-d-circle-outline';
export { default as mdiLetterF } from '~icons/mdi/alpha-f-circle-outline';
export { default as mdiLetterI } from '~icons/mdi/alpha-i-circle-outline';
export { default as mdiLetterL } from '~icons/mdi/alpha-l-circle-outline';
export { default as mdiLetterM } from '~icons/mdi/alpha-m-circle-outline';
export { default as mdiLetterP } from '~icons/mdi/alpha-p-circle-outline';
export { default as mdiLetterR } from '~icons/mdi/alpha-r-circle-outline';
export { default as mdiLetterS } from '~icons/mdi/alpha-s-circle-outline';
export { default as mdiLetterX } from '~icons/mdi/alpha-x-circle-outline';
export { default as mdiLightningBoltOutline } from '~icons/mdi/lightning-bolt-outline';
export { default as mdiListStatus } from '~icons/mdi/list-status';
export { default as mdiLockOutline } from '~icons/mdi/lock-outline';
export { default as mdiMinus } from '~icons/mdi/minus';
export { default as mdiMulticast } from '~icons/mdi/multicast';
export { default as mdiNumeric1CircleOutline } from '~icons/mdi/numeric-1-circle-outline';
export { default as mdiNumeric2CircleOutline } from '~icons/mdi/numeric-2-circle-outline';
export { default as mdiNumeric3CircleOutline } from '~icons/mdi/numeric-3-circle-outline';
export { default as mdiNumeric4CircleOutline } from '~icons/mdi/numeric-4-circle-outline';
export { default as mdiNumeric5CircleOutline } from '~icons/mdi/numeric-5-circle-outline';
export { default as mdiPageFirst } from '~icons/mdi/page-first';
export { default as mdiPageLast } from '~icons/mdi/page-last';
export { default as mdiPartyPopper } from '~icons/mdi/party-popper';
export { default as mdiPlanet } from '~icons/mdi/planet';
export { default as mdiPlus } from '~icons/mdi/plus';
export { default as mdiProgressQuestion } from '~icons/mdi/progress-question';
export { default as mdiPuzzle } from '~icons/mdi/puzzle';
export { default as mdiQuestion } from '~icons/mdi/help-circle-outline';
export { default as mdiQuestionMark } from '~icons/mdi/question-mark';
export { default as mdiRadioboxBlank } from '~icons/mdi/radiobox-blank';
export { default as mdiRadioboxMarked } from '~icons/mdi/radiobox-marked';
export { default as mdiRocketLaunchOutline } from '~icons/mdi/rocket-launch-outline';
export { default as mdiRunFast } from '~icons/mdi/run-fast';
export { default as mdiSafeSquareOutline } from '~icons/mdi/safe-square-outline';
export { default as mdiShieldHalfFull } from '~icons/mdi/shield-half-full';
export { default as mdiSkull } from '~icons/mdi/skull';
export { default as mdiSlotMachineOutline } from '~icons/mdi/slot-machine-outline';
export { default as mdiSortAlphabeticalAscending } from '~icons/mdi/sort-alphabetical-ascending';
export { default as mdiSortAlphabeticalDescending } from '~icons/mdi/sort-alphabetical-descending';
export { default as mdiSortNumericAscending } from '~icons/mdi/sort-numeric-ascending';
export { default as mdiSortNumericDescending } from '~icons/mdi/sort-numeric-descending';
export { default as mdiStarFace } from '~icons/mdi/star-face';
export { default as mdiStarHalfFull } from '~icons/mdi/star-half-full';
export { default as mdiStarOutline } from '~icons/mdi/star-outline';
export { default as mdiSwimDive } from '~icons/mdi/swim-dive';
export { default as mdiSwordCross } from '~icons/mdi/sword-cross';
export { default as mdiTimerSand } from '~icons/mdi/timer-sand';
export { default as mdiTrophy } from '~icons/mdi/trophy';
export { default as mdiTshirtCrew } from '~icons/mdi/tshirt-crew';
export { default as mdiUnicorn } from '~icons/mdi/unicorn';
export { default as mdiWardrobeOutline } from '~icons/mdi/wardrobe-outline';
export { default as mdiWizardHat } from '~icons/mdi/wizard-hat';

export { default as mynauiLetterASquare } from '~icons/mynaui/letter-a-square';
export { default as mynauiLetterCSquare } from '~icons/mynaui/letter-c-square';
export { default as mynauiLetterDCircle } from '~icons/mynaui/letter-d-circle';
export { default as mynauiLetterDSquare } from '~icons/mynaui/letter-d-square';
export { default as mynauiLetterFCircle } from '~icons/mynaui/letter-f-circle';
export { default as mynauiLetterHSquare } from '~icons/mynaui/letter-h-square';
export { default as mynauiLetterICircle } from '~icons/mynaui/letter-i-circle';
export { default as mynauiLetterLSquare } from '~icons/mynaui/letter-l-square';
export { default as mynauiLetterMCircle } from '~icons/mynaui/letter-m-circle';
export { default as mynauiLetterMSquare } from '~icons/mynaui/letter-m-square';
export { default as mynauiLetterNSquare } from '~icons/mynaui/letter-n-square';
export { default as mynauiLetterPCircle } from '~icons/mynaui/letter-p-circle';
export { default as mynauiLetterPSquare } from '~icons/mynaui/letter-p-square';
export { default as mynauiLetterRCircle } from '~icons/mynaui/letter-r-circle';
export { default as mynauiLetterSCircle } from '~icons/mynaui/letter-s-circle';
export { default as mynauiLetterWSquare } from '~icons/mynaui/letter-w-square';
export { default as mynauiNumber1Circle } from '~icons/mynaui/one-circle';
export { default as mynauiNumber2Circle } from '~icons/mynaui/two-circle';
export { default as mynauiNumber3Circle } from '~icons/mynaui/three-circle';
export { default as mynauiNumber4Circle } from '~icons/mynaui/four-circle';

export { default as notoAngryFaceWithHorns } from '~icons/noto/angry-face-with-horns';
export { default as notoBackpack } from '~icons/noto/backpack';
export { default as notoBank } from '~icons/noto/bank';
export { default as notoBrick } from '~icons/noto/brick';
export { default as notoCarrot } from '~icons/noto/carrot';
export { default as notoCloud } from '~icons/noto/cloud';
export { default as notoClownFace } from '~icons/noto/clown-face';
export { default as notoCowboyHatFace } from '~icons/noto/cowboy-hat-face';
export { default as notoCrossedSwords } from '~icons/noto/crossed-swords';
export { default as notoDogFace } from '~icons/noto/dog-face';
export { default as notoFamilyWomanWomanGirlBoy } from '~icons/noto/family-woman-woman-girl-boy';
export { default as notoIce } from '~icons/noto/ice';
export { default as notoPinkHeart } from '~icons/noto/pink-heart';
export { default as notoRose } from '~icons/noto/rose';
export { default as notoSnowflake } from '~icons/noto/snowflake';
export { default as notoSunWithFace } from '~icons/noto/sun-with-face';
export { default as notoWaterWave } from '~icons/noto/water-wave';

export { default as notoV1AngryFaceWithHorns } from '~icons/noto-v1/angry-face-with-horns';

export { default as openmojiFlagFrance } from '~icons/openmoji/flag-france';
export { default as openmojiFlagGermany } from '~icons/openmoji/flag-germany';
export { default as openmojiFlagItaly } from '~icons/openmoji/flag-italy';
export { default as openmojiFlagPortgual } from '~icons/openmoji/flag-portugal';
export { default as openmojiFlagRussia } from '~icons/openmoji/flag-russia';
export { default as openmojiFlagSpain } from '~icons/openmoji/flag-spain';
export { default as openmojiFlagUnitedKingdom } from '~icons/openmoji/flag-united-kingdom';

export { default as solarMasksBold } from '~icons/solar/masks-bold';

export { default as twemojiFlagFrance } from '~icons/twemoji/flag-france';
export { default as twemojiFlagGermany } from '~icons/twemoji/flag-germany';
export { default as twemojiFlagItaly } from '~icons/twemoji/flag-italy';
export { default as twemojiFlagPortgual } from '~icons/twemoji/flag-portugal';
export { default as twemojiFlagRussia } from '~icons/twemoji/flag-russia';
export { default as twemojiFlagSpain } from '~icons/twemoji/flag-spain';
export { default as twemojiFlagUnitedKingdom } from '~icons/twemoji/flag-united-kingdom';
